import $ from 'jquery';
import '../../Language/parsley';
import 'parsleyjs';
import {fetchPrice} from "./Price";


function setObjectByPath(obj, path, value) {
    if (path.length === 0) {
        return value;
    }

    let key = path[0];
    if (key === '') {
        if (!Array.isArray(obj)) {
            obj = [];
        }
    } else {
        if (Array.isArray(obj)) {
            obj = {};
        }
        obj = obj || {};
    }

    let result = setObjectByPath(obj[key] || {}, path.slice(1), value);

    if (Array.isArray(obj)) {
        obj.push(result);
    } else {
        obj[key] = result;
    }

    return obj;
}


/**
 * @param $form
 * @returns {BannerPayload}
 */
function getFormData($form) {
    let formItems = $form.serializeArray();

    const prefix = 'tx_spreebanners_form[banner]';
    /** @var {BannerPayload} */
    let data = {};
    formItems.forEach(item => {
        if (item.name.indexOf(prefix) !== 0) {
            return
        }

        let name = item.name.substring(prefix.length + 1, item.name.length - 1);
        let parts = name.split('][');
        setObjectByPath(data, parts, item.value);
    });

    data.categories = (data.categories || []).map(Number).filter(e => !isNaN(e));
    data.pages = (data.pages || []).map(Number).filter(e => !isNaN(e));
    data.invoiceRecipientEnabled = !!data.invoiceRecipientEnabled; // '' -> false, '1' -> true
    data.associationMember = !!data.associationMember;

    return data;
}

function getSelectedOptionDataProp($select, dataProp, defaultValue) {
    let val = $select.val();
    let $option = $select.find('[value="' + val + '"]');
    return $option.data(dataProp) || defaultValue;
}

function getCheckboxFieldsets($check) {
    if ($check.prop('checked') === false) {
        return [];
    }
    let fieldsets = $check.data('fieldsets') || [];
    if (!Array.isArray(fieldsets) || typeof fieldsets === 'object') {
        fieldsets = Object.values(fieldsets);
    }
    return fieldsets;
}

function updateVisibilities($form) {

    const $allFieldsets = $form.find('*[data-fieldset]');

    $allFieldsets.addClass('d-none');
    $allFieldsets.find('*[data-required="toggle"]').prop('required', false);

    const $placement = $form.find('[name="tx_spreebanners_form[banner][placement]"]');
    const $displayForm = $form.find('[name="tx_spreebanners_form[banner][displayForm]"]');
    const $pagesSelect = $form.find('[name="tx_spreebanners_form[banner][pages][]"]');
    const $categoriesSelect = $form.find('[name="tx_spreebanners_form[banner][categories][]"]');
    const $topPlacementSelect = $form.find('[name="tx_spreebanners_form[banner][topPlacement]"]');
    const languageId = Number($form.find('[name="tx_spreebanners_form[banner][languageId]"]').val());

    let fieldsets = getSelectedOptionDataProp($placement, 'fieldsets', []);
    fieldsets = fieldsets.concat(getSelectedOptionDataProp($displayForm, 'fieldsets', []));
    $form.find('input[type="checkbox"][data-fieldsets]').each((i, elem) => {
        fieldsets = fieldsets.concat(getCheckboxFieldsets($(elem)));
    });
    if ($placement.val() === 'topBooking') {
        fieldsets = fieldsets.concat(getSelectedOptionDataProp($topPlacementSelect, 'fieldsets', []));
    }

    fieldsets.forEach(fieldset => {
        const $fieldset = $form.find('*[data-fieldset="' + fieldset + '"]');
        $fieldset.removeClass('d-none');

        // get all required fields, and check if the closest fieldset is the current one.
        $fieldset.find('*[data-required="toggle"]').each(function () {
            let $field = $(this);
            let $closestFieldset = $field.closest('*[data-fieldset]');
            if ($closestFieldset.length === 0 || $closestFieldset.data('fieldset') === fieldset) {
                $field.prop('required', true);
            }
        });
    });

    function setResolution(fieldset, value) {
        if (!value) {
            return;
        }
        const $resWidth = $(`*[data-fieldset="${fieldset}"] .image-resolution`);
        $resWidth.find('.width').text(value[0]);
        $resWidth.find('.height').text(value[1]);
    }

    setResolution('image-imageMobile', getSelectedOptionDataProp($placement, 'image-mobile', null));
    setResolution('image-imageDesktop', getSelectedOptionDataProp($placement, 'image-desktop', null));

    if (!fieldsets.includes('categoriesAndPages-pages')) {
        $pagesSelect.val('').trigger('change');
    }

    // filter pages
    if (fieldsets.includes('categoriesAndPages')) {
        /** @var {{}} */
        let allPages = $pagesSelect.data('pages').filter(p => p.languageId === languageId);
        let pages = [];
        if ($displayForm.val() === 'selectedPages') {
            // show all pages
            pages = allPages.map(page => {
                return {
                    id: page.uid,
                    text: page.title,
                }
            });
        } else if ($displayForm.val() === 'categorySelectedPages') {
            // show only pages of selected categories
            $pagesSelect.find('option').removeClass('d-none');
            let selectedCategories = ($categoriesSelect.val() || []).map(Number);

            pages = allPages.filter(page => {
                return page.categoryUids.some(e => selectedCategories.includes(e))
            }).map(page => {
                return {
                    id: page.uid,
                    text: page.title,
                }
            });
        } else if ($displayForm.val() === 'categoryAllPages') {
            let selectedCategories = ($categoriesSelect.val() || []).map(Number);
            if (selectedCategories.length > 0) {
                pages = allPages.filter(page => {
                    return page.categoryUids.some(e => selectedCategories.includes(e))
                }).map(page => {
                    return {
                        id: page.uid,
                        text: page.title,
                    }
                });
            } else {
                pages = [];
            }
        }

        // change available options
        if (fieldsets.includes('categoriesAndPages-pages')) {
            let previousValue = $pagesSelect.val();
            $pagesSelect.empty().select2({
                data: pages,
            });
            previousValue.forEach(value => {
                $pagesSelect.find('[value="' + value + '"]').prop('selected', true);
            });
            $pagesSelect.trigger('change');
        } else if (fieldsets.includes('categoriesAndPages-categories-only')) {
            const $pagesListing = $form.find('.pages-listing');
            const $numField = $pagesListing.find('.pages-listing__number');
            $numField.text(pages.length);

            const $list = $pagesListing.find('.pages-listing__list');
            $list.html('');
            pages.forEach(page => {
                $list.append($('<div>', {class: 'pages-listing__page'}).text(page.text));
            });
        }
    }

}


(function () {
    const $form = $('.banner-form form');
    if ($form.length === 0) {
        return;
    }

    $form.find('*[data-fieldset] *[required]').attr('data-required', 'toggle').prop('required', false);

    const $pagesSelect = $form.find('[name="tx_spreebanners_form[banner][pages][]"]');
    $pagesSelect.select2({
        width: '100%',
        minimumResultsForSearch: -1,
    });


    $form.find('.resource-pointer__remove').on('click', function (e) {
        e.preventDefault();
        let $wrap = $(this).closest('.resource-pointer__wrap');
        let $input = $(this).closest('.resource-pointer').find('[name$="[submittedFile][resourcePointer]"]');
        $wrap.remove();
        $input.remove();
    });

    updateVisibilities($form);

    $form.find('*[name]').on('input', async function () {
        const $price = $form.find('.api-price');
        updateVisibilities($form);
        $price.addClass('api-price--loading');
        let result = await fetchPrice(getFormData($form));
        $price.removeClass('api-price--loading');
        let price, days;
        if (result === null) {
            price = 0;
            days = 0;
        } else {
            price = result.price;
            days = result.days;
        }

        let format = days === 1 ? $price.attr('data-singular') : $price.attr('data-plural');
        let priceLabel = (price / 100).toFixed(2) + ' €';
        if ($('html').attr('lang') !== 'en') {
            priceLabel = priceLabel.replace('.', ',');
        }

        let dayLabel = String(days);
        let args = [priceLabel, dayLabel];

        // replace %s with the arguments in order.
        // price and days are numbers, so escaping is not needed.
        let output = format.replace(/%s/g, () => args.shift());

        // replace %N$s with the arguments of the N-1th index.
        output = output.replace(/%(\d+)\$s/g, (match, index) => args[Number(index) - 1]);
        $price.find('.api-price__content').html(output);
    });

    $form.parsley();

})();
